export default {
      id: "picto-quote-top-usage",
      viewBox: "0 0 40 30",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#picto-quote-top-usage",
      toString: function () {
        return this.url;
      }
    }